var _classCallCheck = require("/home/phillipe/Documentos/Workspace/ico_sam/front/sam-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/phillipe/Documentos/Workspace/ico_sam/front/sam-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/phillipe/Documentos/Workspace/ico_sam/front/sam-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/phillipe/Documentos/Workspace/ico_sam/front/sam-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/phillipe/Documentos/Workspace/ico_sam/front/sam-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var rumor = require('rumor')('housecall');
var _ = require('lodash');
var EventEmitter = require('events');
var Queue = /*#__PURE__*/function (_EventEmitter) {
  "use strict";

  _inherits(Queue, _EventEmitter);
  function Queue() {
    var _this;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$concurrency = _ref.concurrency,
      concurrency = _ref$concurrency === void 0 ? 10 : _ref$concurrency,
      _ref$cooldown = _ref.cooldown,
      cooldown = _ref$cooldown === void 0 ? 0 : _ref$cooldown;
    _classCallCheck(this, Queue);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Queue).call(this));
    _this.concurrency = concurrency;
    _this.cooldown = cooldown;
    _this.noCompleted = 0;
    _this.noErrors = 0;
    _this._running = [];
    _this._staging = [];
    _this._enqueued = [];
    _this.earliestExecution = Date.now();
    return _this;
  }
  _createClass(Queue, [{
    key: "executionDelay",
    value: function executionDelay() {
      var now = Date.now();
      if (this.earliestExecution < now) this.earliestExecution = now;
      this.earliestExecution += this.cooldown;
      return this.earliestExecution - now;
    }
  }, {
    key: "pending",
    value: function pending() {
      return this._enqueued.length;
    }
  }, {
    key: "running",
    value: function running() {
      return this._running.length;
    }
  }, {
    key: "staging",
    value: function staging() {
      return this._staging.length;
    }
  }, {
    key: "readyToPop",
    value: function readyToPop() {
      return this._running.length + this._staging.length < this.concurrency && this._enqueued.length > 0;
    }
  }, {
    key: "allDone",
    value: function allDone() {
      return this._running.length === 0 && this._staging.length === 0 && this._enqueued.length === 0;
    }
  }, {
    key: "delay",
    value: function delay(ms) {
      // eslint-disable-line class-methods-use-this
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }
  }, {
    key: "pop",
    value: function pop() {
      var _this2 = this;
      if (this.readyToPop()) {
        var fx = this._enqueued.shift();
        this._staging.push(fx);
        this.delay(this.executionDelay()).then(function () {
          _this2._staging.splice(_this2._staging.indexOf(fx), 1);
          _this2._running.push(fx);
          rumor.debug("".concat(_this2.running(), " running, ").concat(_this2.staging(), " staging and ").concat(_this2.pending(), " pending."));
        }).then(function () {
          var result;
          try {
            result = fx();
          } catch (e) {
            rumor.error(e);
            _this2.noErrors += 1;
          }
          return Promise.resolve(result);
        }).catch(function (err) {
          rumor.error(err);
          _this2.noErrors += 1;
          return Promise.resolve();
        }).then(function () {
          _this2._running.splice(_this2._running.indexOf(fx), 1);
          _this2.noCompleted += 1;
        }).then(this.pop.bind(this));
      } else if (this.allDone()) {
        this.emit('idle', this.noCompleted, this.noErrors);
      }
    }
  }, {
    key: "push",
    value: function push(fx) {
      var _this3 = this;
      var tasks = _.isArray(fx) ? fx : [fx];
      tasks.forEach(function (task) {
        if (!_.isFunction(task)) throw new Error('Push only functions that returns promises to the queue.');
        _this3._enqueued.push(task);
        _this3.pop();
      });
    }
  }]);
  return Queue;
}(EventEmitter);
module.exports = function (config) {
  var result = new Queue(config);
  return result;
};